import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';
import { ExpenseService } from 'src/app/services/expense.service';

@Component({
    selector: 'app-deposit-actions',
    templateUrl: './deposit-actions.component.html',
    styleUrls: ['./deposit-actions.component.scss']
})
export class DepositActionsComponent {
    cellValue!: any;

    constructor(
        private permissionService: PermissionService,
        private router: Router,
        private expenseService: ExpenseService
    ) {}

    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
    }

    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        return true;
    }

    get data(): any { return this.cellValue?.data; }
    get module(): string { return this.data?.module || 'Control de gastos'; }
    get expenseId(): number { return this.data?.service?.id || this.data?.id; }
    get depositsCount(): number { return this.data?.deposits_count ?? 0; }
    get hasExpense(): boolean { return !!(this.data?.has_expense || this.data?.expense_id); }

    get isExpenseValidated(): boolean {
        return !!(this.data?.expense_validated);
    }

    get isFinishedOrDelivered(): boolean {
        const dataStatus: any[] = this.cellValue?.parent?.dataStatus || [];
        const found = dataStatus.find((s: any) => String(s.id) === String(this.data?.status_id));
        const name = String(found?.name ?? '').toLowerCase();
        return name.includes('finaliz') || name.includes('entregad');
    }

    get isSharedTab(): boolean {
        return this.cellValue?.parent?.activeListTab === 'compartidos';
    }

    get isOnlyActiveInGroup(): boolean {
        return (this.data?.__groupActiveCount ?? 0) <= 1;
    }

    get hideWriteActions(): boolean {
        return this.isSharedTab && !this.isFinishedOrDelivered && !this.isOnlyActiveInGroup;
    }

    canDo(action: string): boolean {
        return this.permissionService.canDo(this.module, action);
    }

    download(): void {
        this.expenseService.downloadPdf(this.expenseId).subscribe({
            next: (blob: Blob) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `validacion_gastos_${this.expenseId}.pdf`;
                a.click();
                URL.revokeObjectURL(url);
            }
        });
    }

    goViaticos(): void {
        const tab = this.isSharedTab ? 'compartidos' : 'unicos';
        this.router.navigate(['/service/expense-report', this.expenseId], { queryParams: { from: 'deposits', tab } });
    }

    addDeposit(): void {
        const serviceId = this.data?.service?.id || this.data?.service_id || this.data?.id;
        if (serviceId) {
            const currentPage = this.cellValue?.parent?.currentPage ?? 1;
            const scrollTop = this.cellValue?.parent?.getScrollTop?.() ?? 0;
            this.router.navigate(['/service/deposit', serviceId], { queryParams: { returnPage: currentPage, scrollTop } });
        }
    }

    verify(): void {
        this.router.navigate(['/service/expense-validation', this.expenseId]);
    }
}
